export const SIDEBAR_WIDTH_EXPANDED = 300;
export const SIDEBAR_WIDTH_COLLAPSED = 72;
export const SIDEBAR_COLLAPSE_STORAGE_KEY = 'fyle.sidebarCollapsed';
export const SIDEBAR_DESKTOP_BREAKPOINT = 768;

export const SIDEBAR_WIDTH_MOBILE_SM = 260;
export const SIDEBAR_WIDTH_MOBILE = 280;

export const CSS_VAR_SIDEBAR_WIDTH = '--sidebar-width';

export function getSidebarWidthPx(
  isDesktop: boolean,
  isCollapsed: boolean
): number {
  if (!isDesktop) return 0;
  return isCollapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED;
}
